<template>
    <div class="companyManagement"
      v-loading="showLoad"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <iframe class="register-iframe" :src="companyManagementUrl" frameborder="0" @load="iframeLoad"
        ></iframe>
    </div>
</template>


<script>
import Url from "../../../service/base-url.js";
import { mapState } from "vuex";
export default {
  name: "companyManagement",
  data() {
    return {
      showLoad: true
    };
  },
  methods: {
    iframeLoad() {
      this.showLoad = false;
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    companyManagementUrl() {
      return Url.oaUrl + "/HRPerson/List?appid=" + "1611221534010000101";
    }
  }
};
</script>
<style lang="stylus" scoped>
.companyManagement
  height: 100%;
  .register-iframe
    width: 100%;
    height: 100vh;   
</style>
